// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpm-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #0c1515;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.cpm-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
  letter-spacing: 0.5px;
}

.cpm-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0c1515;
  color: #9aa3ad;
  gap: 16px;
  z-index: 2;
}

.cpm-loading-text {
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 500;
  color: #00d5b9;
}

.cpm-error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0c1515;
  padding: 24px;
  text-align: center;
  color: white;
  z-index: 2;
}

.cpm-error-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.cpm-error-container h3 {
  font-size: 18px;
  margin-bottom: 8px;
  font-weight: 600;
}

.cpm-error-container p {
  font-size: 14px;
  color: #9aa3ad;
  margin-bottom: 24px;
}

.cpm-error-close-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.cpm-error-close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Certifications/CertificatePreviewModal/CertificatePreviewModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".cpm-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background-color: #0c1515;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.cpm-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  letter-spacing: 0.5px;\n}\n\n.cpm-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #0c1515;\n  color: #9aa3ad;\n  gap: 16px;\n  z-index: 2;\n}\n\n.cpm-loading-text {\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n  color: #00d5b9;\n}\n\n.cpm-error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #0c1515;\n  padding: 24px;\n  text-align: center;\n  color: white;\n  z-index: 2;\n}\n\n.cpm-error-icon {\n  font-size: 40px;\n  margin-bottom: 16px;\n}\n\n.cpm-error-container h3 {\n  font-size: 18px;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.cpm-error-container p {\n  font-size: 14px;\n  color: #9aa3ad;\n  margin-bottom: 24px;\n}\n\n.cpm-error-close-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: white;\n  padding: 8px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.cpm-error-close-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
